/* eslint-disable no-loss-of-precision */
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import store from "./store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ThemeProvider } from "next-themes";
import "react-loading-skeleton/dist/skeleton.css";


ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          style={{ zIndex: 99999999999999999999999999 }}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          // className={"!capitalize"}
        />
         <ThemeProvider enableSystem={true} attribute="class">

        <App />
         </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
